import config from '../config';
import { getItemDatosSesion } from './manejosesion';
import { validarCampoString } from './utils';
let unirest = require('unirest')

const obtenerToken = (usuario) => {	
	return new Promise((resolve, reject) => {
		unirest.post(config.apiReportes + '/login')
		.headers({'Content-Type': 'application/x-www-form-urlencoded'})
		.send({ "username": usuario })
        .end(function (response) {            
			if (response.code === 200 && response.headers && response.headers.authorization)
				resolve(response.headers.authorization)
			else
				reject('No se pudo obtener autorización en la aplicación de reportes.');
		});
	});
}

export const visualizarReporteEnPdf = (filtrosUrlReporte) => {
    try{
        const username = getItemDatosSesion('usuario');
        if (!validarCampoString(username, 1, 10)){
            throw new Error('No se puede determinar cual es el usuario que está trabajando en la sesión actual.');
        }
        
        const empresaId = getItemDatosSesion('empresaActual')!==undefined?JSON.parse(getItemDatosSesion('empresaActual')).Id:'';
        if (!validarCampoString(empresaId, 1, 3)){
            throw new Error('No se puede determinar cual es la empresa con la que está trabajando la sesión actual.');
        }

        if (!validarCampoString(filtrosUrlReporte, 1, 200)){
            throw new Error('No se han especificado los parámetros necesarios del reporte a renderizar.');
        }
                
        obtenerToken(username)
        .then((token)=>{        
            let urlReport= config.apiReportes + "/reportes?ft=1&tk=" + token + "&emp=" + empresaId + filtrosUrlReporte;
            window.open(urlReport, "_blank", "scrollbars=yes, resizable=yes, width=900, height=650");
        })
        .catch((error)=>{
            alert("Ocurrió un error al instanciar reporte: " + error);
        });
    }
    catch(error){
        alert("Ocurrió un error al generar los parámetros del reporte: " + error);
    }
}

export const generarReporteEnExcel = (filtrosUrlReporte) => {
    try{
        const username = getItemDatosSesion('usuario');
        if (!validarCampoString(username, 1, 10)){
            throw new Error('No se puede determinar cual es el usuario que está trabajando en la sesión actual.');
        }
        
        const empresaId = getItemDatosSesion('empresaActual')!==undefined?JSON.parse(getItemDatosSesion('empresaActual')).Id:'';
        if (!validarCampoString(empresaId, 1, 3)){
            throw new Error('No se puede determinar cual es la empresa con la que está trabajando la sesión actual.');
        }

        if (!validarCampoString(filtrosUrlReporte, 1, 200)){
            throw new Error('No se han especificado los parámetros necesarios del reporte a generar.');
        }
                
        obtenerToken(username)
        .then((token)=>{        
            let urlReport= config.apiReportes + "/reportes?ft=2&tk=" + token + "&emp=" + empresaId + filtrosUrlReporte;
            window.open(urlReport, "_blank", "scrollbars=yes, resizable=yes, width=450, height=250");
        })
        .catch((error)=>{
            alert("Ocurrió un error al instanciar reporte: " + error);
        });
    }
    catch(error){
        alert("Ocurrió un error al instanciar reporte: " + error);
    }
}